const {allLanguages} = require("../../languages");
const getLangs = (pageContext, data = {}, onlyAlternates = false) => {
    const locale = data?.locales?.edges?.[0]?.node?.language ?? pageContext?.i18n?.language ?? 'en';
    const langs = allLanguages.map(lang => {
        return {
            locale: lang.code,
            label: lang.shortName.toUpperCase(),
            selected: false,
            url: `/${lang.code}`,
            title: lang.shortName.toUpperCase(),
        };
    });

    langs.find((item) => item.locale === locale).selected = true;
    langs.map((lang) => {
        if (onlyAlternates) {
            if (pageContext?.alternates?.[lang.locale]) {
                lang.url = pageContext.alternates[lang.locale].url;
                if (pageContext.alternates[lang.locale].title) {
                    lang.title = pageContext.alternates[lang.locale].title;
                }
            } else {
                lang.url = null;
            }
        } else {
            if (pageContext?.alternates?.[lang.locale]) {
                lang.url = pageContext.alternates[lang.locale].url;
                if (pageContext.alternates[lang.locale].title) {
                    lang.title = pageContext.alternates[lang.locale].title;
                }
            } else if (pageContext?.i18n?.originalPath && pageContext?.i18n?.path && pageContext?.i18n?.originalPath === pageContext?.i18n?.path) {
                lang.url = `${pageContext.i18n.path}`;
            } else if (pageContext?.i18n?.originalPath === '/blog/') {
                lang.url = `/${lang.locale}${pageContext.i18n.originalPath}`;
            }
        }
    });
    return langs.filter(item => item.url !== null);
}
export {getLangs};
